// Generated by CoffeeScript 2.7.0
import $ from "jquery";

$(function() {
  return $('.js__sign_up').on('ajax:error', function(event, xhr) {
    var errors, meta_data;
    meta_data = JSON.parse(xhr.responseText).meta;
    if (meta_data.error_type === 'AuthenticationTokenExpired') {
      window.location.href = meta_data.options.redirect_path;
      return;
    }
    errors = meta_data.errors;
    // Append error elements
    return $.each(errors, function(key, values) {
      var errorWrapper;
      errorWrapper = $(`[name=student\\[${key}\\]]`).next();
      return $.each(values, function(index) {
        var error_message, newError;
        error_message = values[index];
        newError = $('<li>').html(error_message);
        return errorWrapper.append(newError);
      });
    });
  }).on('ajax:success', function(e) {
    return window.location.href = '/thankyou/';
  }).on('ajax:before', function(e) {
    return $('.errors').empty();
  }).on('ajax:beforeSend', function(e) {
    return $(this).find('input[type="submit"]').attr('disabled', true);
  });
});
